<template>
  <div class="pases-reservados">
    <div class="pr-header">Pases</div>
    <div class="pr-header">Dia</div>
    <div class="pr-header">Hora</div>
    <div class="pr-header edit"><img :src="IconMaterialEdit" alt="edit" /></div>
    <template v-for="pase in pasesReservados" :key="pase.id">
      <div class="actividad">
        <span>{{ pase.actividad }}</span
        ><span class="sede">({{ pase.sede }})</span>
      </div>
      <div>{{ pase.fechaUX }}</div>
      <div>{{ pase.hora }}</div>
      <div class="pointer" :class="{ disabled: !pase.canCancel }" :data-pase="pase.id" @click="openMenu(pase.id, pase.canCancel)">
        <!-- 
          <img :src="IconEdit" alt="edit" />
          -->

        <IconEdit :color="iconColor(pase.canCancel)" />
      </div>
    </template>
  </div>
</template>
<script setup>
  import IconEdit from "@/components/svg/edit.vue"
  import IconMaterialEdit from "@/assets/svg/material-edit.svg"

  defineProps({
    pasesReservados: {
      type: Array,
      default: [],
    },
  })

  const emit = defineEmits({ edit: "String" })
  const openMenu = (paseId, canCancel) => {
    if (canCancel) {
      emit("edit", paseId)
    }
  }

  const iconColor = (canCancel) => {
    if (canCancel) {
      return "#1a9bf8"
    } else {
      return "#c4c4c4"
    }
  }
  // const { updateValue } = SetupFormComponent(props, emit)
</script>
<style>
  .pases-reservados {
    display: grid;
    grid-template-columns: calc(60% - 20px) calc(20% - 6px) calc(20% - 6px) 32px;
    background-color: #4687c333;
    border: 1px solid #4687c333;
    border-radius: 3px;
    font-size: 1rem;
    margin-top: 20px;
  }

  .pases-reservados div {
    background-color: #ffff;
    color: #363636;
    border: 1px solid #4687c333;
    padding: 10px 0px 10px 10px;
    display: flex;
    align-items: center;
  }

  .pases-reservados .pr-header {
    background-color: #387dbe;
    color: #ffff;
  }

  .pases-reservados .actividad {
    display: grid;
  }

  .pases-reservados .sede {
    font-size: 0.8rem;
  }

  .pases-reservados .edit {
    display: flex;
    justify-content: center;
    padding: 0;
  }

  .edit img {
    width: 14px;
  }

  .pases-reservados .pointer {
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  @media (min-width: 480px) {
    .pases-reservados div {
      padding: 10px 0px 10px 15px;
    }
  }

  @media (min-width: 720px) {
    .pases-reservados {
      grid-template-columns: 300px 100px 100px 50px;
    }
  }
</style>
